module.exports = __webpack_public_path__ + "img/orange_024.326bc019.png";